import Icon from '@/components/Icon'
import { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { useUI } from '@/context/ui'
import { Tab } from '@headlessui/react'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { useTranslation } from 'next-i18next'
import React, { useEffect, useState } from 'react'
import * as styles from './styles'

dayjs.extend(relativeTime)

interface Props {
  data: {
    tabTitle: JSX.Element | string
    disabled?: boolean
  }[]
  onFiltersClicked: () => void
  onDateClicked?: () => void
  hide?: boolean
  hideTabs?: boolean
  defaultTabIndex: number
  tabIndex: number
  onTabChange: (index: number) => void
  activeFiltersCount: number
}

let scroll = 0

const ScheduleScrollTabs: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')
  const {
    state: { calendarSelectedDay },
  } = useUI()
  const [reducePadding, setReducePadding] = useState(false)

  const onScroll = (): void => {
    if (typeof window === 'undefined' || !document) {
      return
    }
    const doc = document.getElementById('schedule-page-tabs')
    if (!doc) return
    if (window.scrollY <= 0) {
      setReducePadding(false)
    } else {
      setReducePadding(true)
    }
    scroll = window.scrollY
  }

  useEffect(() => {
    window.removeEventListener('scroll', onScroll)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <div id="schedule-page-tabs" className={`${styles.tabBox} ${props.hide ? 'hide' : ''}`}>
      <div className={styles.tabWrapper}>
        <div className={styles.tabfixedWrapper}>
          <div className={`${props.hideTabs ? 'hide' : ''} bg-tertiary-20`}>
            <Tab.Group defaultIndex={props.defaultTabIndex} selectedIndex={props.tabIndex} onChange={props.onTabChange}>
              <Tab.List data-headlessui-tab-list>
                {props.data.map((item) => (
                  <Tab key={item.tabTitle.toString()} disabled={item.disabled}>
                    {item.tabTitle}
                  </Tab>
                ))}
              </Tab.List>
            </Tab.Group>
          </div>
          {props.tabIndex === 0 ? (
            <Stack
              className={`${styles.facetWrapper} pt-xs pb-xs ${reducePadding ? styles.bottomShadow : 'pt-lg pb-sm'}`}
            >
              <Text size="md" weight="lg">
                {dayjs().format('YYYY-MM-DD') === dayjs(calendarSelectedDay).format('YYYY-MM-DD')
                  ? t('search.today')
                  : dayjs(calendarSelectedDay).format('ddd D MMM')}
              </Text>
              <div className="flex-center gap-xxs" onClick={props.onFiltersClicked}>
                <Icon size={15} name="filters-blue" />
                <Text size="xs">{t('search.filters')}</Text>
                {props.activeFiltersCount > 0 ? (
                  <span className={styles.filterCount}>{props.activeFiltersCount}</span>
                ) : null}
              </div>
            </Stack>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default ScheduleScrollTabs
